// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";

window.initDom = ($wrapper) => {
    console.debug($wrapper, 'init');
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
}

(function() {
    window.initDom(document);
})();
